import React from 'react';

import i18n from '@yandex-int/i18n';
import { wrapInText } from 'client/lib/i18n-utils';
import * as keysetAlice from 'i18n/AliceSkillForm';
import * as keyset from 'i18n/SettingsLabels';
import * as keysetThereminvox from 'i18n/Thereminvox';

import { routes } from '../../../lib/routes';
import { SkillAccess } from '../../../model/settings';
import { DevPreviewBanner } from '../../DocumentationPage/DevPreviewBanner';
import Description from '../../Form/Description/Description';
import Link, { StoreLink } from '../../Link/Link';

const t = i18n(keyset);
const tAlice = i18n(keysetAlice);
const tSynth = i18n(keysetThereminvox);

const wrapStoreLink = wrapInText((s) => <StoreLink>{s}</StoreLink>);

const wrapWebmasterLink = wrapInText((s) => (
    <Link to="https://webmaster.yandex.ru/sites/add/" target="_blank">
        {s}
    </Link>
));

export const brandVerificationWebsiteCaptionSkill = <span>{wrapWebmasterLink(t('description-verification'))}</span>;

export const emailDescription = (isEmailSent: boolean) => (
    <Description offsetBottom={isEmailSent}>
        {isEmailSent && <p style={{ color: '#cb2d2d' }}>{t('description-email-sent')}</p>}
        <p>
            <span>{t('description-email')}</span>
        </p>
    </Description>
);

export const activationPhrasesCaption = <span>{tAlice('description-activation')}</span>;

export const skillNameCaption = <span>{wrapStoreLink(tAlice('description-skill-name'))}</span>;

export const structuredExamplesCaption = (
    <span>
        {wrapInText(
            (s) => <StoreLink>{s}</StoreLink>,
            (s) => <span style={{ fontWeight: 'bold' }}>{s}</span>,
        )(tAlice('description-activation-examples'))}
    </span>
);

export const thereminvoxNameDescription = <Description>{tSynth('description-name')}</Description>;

export const thereminvoxHideInStoreDescription = <Description>{tSynth('description-privacy')}</Description>;

export const isTrustedSmartHomeSkillDescription = (
    <Description>
        {wrapInText((s) => <Link to={routes.documentation.smartHome.trustedSkills}>{s}</Link>)(
            t('description-official'),
        )}
    </Description>
);

export const stateFlagDescription = (
    <>
        <Description offsetBottom>
            {wrapInText((s) => <Link to={routes.documentation.aliceSkills.stateStorage}>{s}</Link>)(
                tAlice('storage-description'),
            )}
        </Description>
        <div style={{ fontSize: '13px' }}>
            <DevPreviewBanner />
        </div>
    </>
);

export const rsyFieldDescription = (
    <Description>
        {wrapInText((s) => (
            <Link to={routes.documentation.aliceSkills.rsy} target="_blank">
                {s}
            </Link>
        ))(tAlice('description-rtb-id'))}
    </Description>
);

const hiddenDescription = () => {
    return __appConfig.isYangoRequest ? (
        <Description>{t('description-access-hidden-yango')}</Description>
    ) : (
        <Description>{wrapStoreLink(t('description-access-hidden'))}</Description>
    );
};

const publicDescription = () => {
    return __appConfig.isYangoRequest ? (
        <Description>{t('description-access-public-yango')}</Description>
    ) : (
        <Description>{wrapStoreLink(t('description-access-public'))}</Description>
    );
};

const privateDescription = () => {
    return __appConfig.isYangoRequest ? (
        <Description>{t('description-access-private-yango')}</Description>
    ) : (
        <Description>{wrapStoreLink(t('description-access-private'))}</Description>
    );
};

export const commonAccessDescriptions = {
    [SkillAccess.Hidden]: hiddenDescription,
    [SkillAccess.Private]: privateDescription,
    [SkillAccess.Public]: publicDescription,
};
